import Swiper, {Navigation} from "swiper";

class ProgramFeedbackSlider {
    constructor(el) {
        this.el = el;
        this.swiperNode = this.el.querySelector(".js-program-feedback-swiper");
        this.prevButton = this.el.querySelector(".js-swiper-prev");
        this.nextButton = this.el.querySelector(".js-swiper-next");

        this.createSlider();
    }

    createSlider() {
        this.swiper = new Swiper(this.swiperNode, {
            modules: [Navigation],
            slidesPerView: 1,
            clickable: true,
            slideToClickedSlide: true,
            spaceBetween: 8,
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            },
        });
    }
}

document.querySelectorAll(".js-program-feedback").forEach((el) => new ProgramFeedbackSlider(el));
